import {
  Space,
  Row,
  Col,
  Button,
  Table,
  Typography,
  Divider,
  Popover,
  message,
  notification,
} from "antd";
import React, { useEffect, useRef, useState } from "react";

import {
  ColumnPopoverDisplay,
  ExpandSearch,
  ListActionButton,
} from "components/common";
import Icons from "assets/icons";
import { ExcelSVG } from "assets";
import { allColumns as columnsInit } from "./License.config";
import { employeeService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getGiayPhepAPI } from "redux/reducer/employee";
import axiosClient from "../../../../../../api/axiosClient";
import ModalCustom from "../../../../../../components/common/ModalCustom/ModalCustom";
import moment from "moment";
import FormAdd from "./FormAdd/FormAdd";
import Notification from "../../../../../../components/common/notification/notification";

import dayjs from "dayjs";
import {
  formatDateToString,
  generateFileName,
  saveTableOptions,
  getTableOptions,
} from "../../../../../../helper/common";
import { FORMAT_TIME } from "../../../../../../types/enums";
import { ColumnProps } from "../../../../../../types/models";
import { allColumns } from "../../../../SalaryManagement/Timekeeping/Tab/ListTimekeeping.config";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";

const License = () => {
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const dispatch = useAppDispatch();
  let idEmp = useAppSelector((state) => state.employeesReducer.idEmp);
  const employeesStore = useAppSelector((state) => state.employeesReducer);
  let status = useAppSelector((state) => state.employeesReducer.status);
  const modalRef = useRef<any>();
  const [loading, setLoading] = useState(false);
  let savedTableOption = getTableOptions(
    "LICENSE_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? columnsInit.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : columnsInit;
  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter((e) => e.show === true)
  );
  columns.map((e) => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 1000,
  });
  useEffect(() => {
    getListGiayPhep(idEmp);
  }, [idEmp]);
  const getListGiayPhep = async (id) => {
    setLoading(true);
    if (idEmp !== null) {
      setSelectedRowKeys([]);
      await dispatch(getGiayPhepAPI(id));
      setLoading(false);
    } else {
      if (status == true) {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    const newColumns = columns;
    columns.find((e) => e.dataIndex == "action").render = (
      value,
      _record,
      index
    ) => {
      return (
        <ListActionButton
          deleteFunction={() => {
            deleteLicense(_record.id);
          }}
          editFunction={() => {
            setType("Sửa");
            setRecord(_record);
            modalRef.current?.openModal();
          }}
        ></ListActionButton>
      );
    };
    setColumns(newColumns);
  }, []);
  useEffect(() => {}, [record]);
  useEffect(() => {
    setLoading(true);
    if (employeesStore.giayPhepList !== null) {
      setData(
        employeesStore.giayPhepList.map((license) => ({
          ...license,
          soYTe: license.soYTe !== null ? license.soYTe : "_",
          // ngayCoHieuLuc : license?.ngayCoHieuLuc ? dayjs(license.ngayCoHieuLuc).format(FORMAT_TIME.dayFull) : null,
          phamViHoatDong:
            license.phamViHoatDong !== null ? license.phamViHoatDong : "_",
        }))
      );
    }
    setLoading(false);
  }, [employeesStore.giayPhepList]);

  const onChangePagination = (page, pageSize) => {
    setParams({ ...params, page: page, limit: pageSize });
  };

  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "LICENSE_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const deleteLicense = async (id) => {
    setLoading(true);
    try {
      setLoading(true);
      const res = await employeeService.deleteLicense(id);
      Notification("success", "Đã xóa dữ liệu vừa chọn");
      setLoading(false);
      getListGiayPhep(idEmp);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu");
    }
    setLoading(false);
  };
  const handleExportExcel = async (id) => {
    try {
      if (id !== null) {
        const url = "hanhchinhnhansu/giay-phep/export-excel";
        const baseName = "danh-sach-giay-phep";
        const fileExtension = "xlsx";
        const fileName = generateFileName(baseName, fileExtension);

        const response = await axiosClient.post(url, id, {
          responseType: "blob",
        });

        const blob = await response.data;

        // Create a blob URL
        const blobUrl = URL.createObjectURL(blob);

        // Create a link element for downloading
        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.download = fileName;

        // Append the link to the document, trigger click, and remove the link
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        Notification("warning", "Chọn nhân viên để xuất giấy phép");
        console.error("chọn nhân viên để xuất giấy phép");
      }
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      console.error("Error exporting Excel:", error);
      Notification("error", "Error exporting Excel");
    }
  };

  return (
    <div className="medicine-container">
      <div className="container">
        <Space style={{ width: "100%" }} direction="vertical">
          <Row justify={"space-between"} gutter={[16, 8]}>
            <Col>
              <Popover
                trigger="click"
                placement="topLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={columns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button
                  icon={<Icons.bars rev={0} />}
                  className="btn-sub"
                  type="ghost"
                >
                  Cột hiển thị
                </Button>
              </Popover>
            </Col>
            <Col>
              <Space style={{ width: "100%" }}>
                <Button
                  className="custom-btn"
                  icon={<ExcelSVG />}
                  onClick={() => handleExportExcel(idEmp)}
                >
                  <Typography>Xuất báo cáo</Typography>
                </Button>

                <Button
                  type="primary"
                  onClick={() => {
                    setType("Thêm");
                    setRecord(null);
                    modalRef.current?.openModal();
                  }}
                >
                  Thêm mới
                </Button>
              </Space>
            </Col>
          </Row>
          {data && (
            <CustomResizableTable
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,

                onChange: onChangePagination,
              }}
              setShowColumns={setShowColumnsList}
              columns={columns}
              dataSource={data}
              bordered={true}
              loading={loading}
              scroll={{ x: 900 }}
            />
          )}
          <ModalCustom
            ref={modalRef}
            width={1400}
            title={`${type} mới giấy phép hành nghề`}
          >
            <FormAdd
              data={record}
              getListApi={getListGiayPhep}
              type={type}
              idEmp={idEmp}
              setCurrentPage={null}
            ></FormAdd>
          </ModalCustom>
        </Space>
      </div>
    </div>
  );
};

export default License;
